import {
  swiperTemplate1Blueprint,
  swiperPaginationBlueprint,
  swiperNavigationBlueprint,
  swiperListBlueprint,
} from "@made-people/blueprint-swiper/blueprint";

swiperPaginationBlueprint.override({
  slots: {
    wrapper: "w-full px-[var(--spacing-x)]",
  },
});

swiperNavigationBlueprint.override({
  slots: {
    wrapper: "absolute top-0 left-0 w-full h-full pointer-events-none",
    rightArrow:
      "pointer-events-auto right-[calc(var(--spacing-x)-18px)] absolute top-1/2 -translate-y-1/2 z-30 disabled:scale-0 scale-100 transition-all w-10 h-10 p-3 [&>svg]:ml-0.5 bg-white shadow-sm rounded-full hover:scale-110 active:scale-100",
    leftArrow:
      "pointer-events-auto absolute left-[calc(var(--spacing-x)-18px)] top-1/2 -translate-y-1/2 z-30 disabled:scale-0 scale-100 transition-all w-10 h-10 p-3 bg-white shadow-sm rounded-full hover:scale-110 active:scale-100",
  },
  variants: {
    color: {
      white: {
        rightArrow: "bg-white border border-black [&>svg]:text-black",
        leftArrow: "bg-white border border-black [&>svg]:text-black",
      },
      surface: {
        rightArrow: "bg-beige-50 shadow-none",
        leftArrow: "bg-beige-50 shadow-none",
      },
    },
  },
});

swiperListBlueprint.override({
  slots: {
    wrapper:
      "py-2 flex w-full gap-[var(--gap)] px-[var(--spacing-x)] scroll-px-[var(--spacing-x)] snap-mandatory snap-x overflow-x-scroll overflow-y-visible box-border page-max-width:px-0 page-max-width:scroll-px-0 page-max-width:mx-[var(--spacing-x)] page-max-width:w-[calc(100%-(var(--spacing-x)*2))]",
    item: "w-[calc((100%-(var(--gap)*(var(--items-in-view)-1)))/var(--items-in-view))] grow-0 shrink-0 snap-start overflow-y-visible transition-all",
  },
});

swiperTemplate1Blueprint.override({
  slots: {
    wrapper: "relative z-0  my-[var(--spacing-y)] w-full",
    container:
      "grid grid-cols-[1fr_max-content] w-full box-border gap-4 md:gap-4 lg:gap-6 max-w-[calc(var(--page-max-width)+(var(--spacing-x)*2))] ml-auto mr-auto",
    listWrapper: "col-span-2 relative w-full h-full",
    header: "w-full px-[var(--spacing-x)] flex justify-between",
    linkWrapper: "px-[var(--header-spacing-x)] self-end",
    link: "mb-1.5 shrink-0",
  },
  variants: {
    layout: {
      stacked: {
        listWrapper: "",
        header: "justify-between items-end",
      },
      inline1: {
        container: "flex-row",
        listWrapper: "w-2/3 shrink-0",
        list: "pl-0",
        header: "flex-col items-start",
      },
      inline2: {
        container: "flex-row",
        listWrapper: "w-1/2 shrink-0",
        list: "pl-0",
        header: "flex-col items-start",
      },
    },
    background: {
      none: {
        wrapper: "",
      },
      surface: {
        wrapper: "bg-surface-1 py-8 md:py-12 lg:py-16",
      },
      white: {
        wrapper: "bg-white py-4 md:py-6 lg:py-8",
      },
    },
  },
});
